import { FormFieldData } from "modules/forms";
import { IMapper } from "shared/types/IMapper";
import { ConvertToUTC } from "shared/utils/date.utils";
import { UpdateIssueRequest } from "../mutations/ammend-issue.mutations.types";
import { IssueEntity } from "shared/types/domain/IssueEntity";

export class UpdateIssueRequestMapper implements IMapper<FormFieldData<IssueEntity>, UpdateIssueRequest> {
    map(entity: FormFieldData<IssueEntity>): UpdateIssueRequest {
        return {
            issueId: entity.nearMissId,
            concernLevel: entity.concernLevel,
            locationType: entity.locationType,
            depotPcId: entity.depotPcId,
            whatHappened: entity.whatHappened,
            howToStop: entity.howToStop,
            reporterType: entity.reporterType,
            anonymousEntry: entity.anonymousEntry,
            contactName: entity.reporterContactName,
            contactPhoneNumber: entity.reporterPhoneNumber,
            contactEmail: entity.reporterEmail,
            incidentDate: ConvertToUTC(entity.incidentDate),
            enhancements: {
                processId: entity.processId,
                reachId: entity.reachId
            }
        }
    };
}